import { BaseBloc } from '@core/utils/bloc';
import { resolve } from '@core/utils/ioc';
import { Blocs } from '@business/blocs';
import { forkJoin, of } from 'rxjs';
import { LoadingState } from '@core/utils/repository/loading_state';
import { map } from 'rxjs/operators';
import { R } from '@core/utils/r';
import { OrgId } from '@business/entities/organization';

export class ProposalsPageBloc extends BaseBloc {
  private readonly proposalBloc = resolve(Blocs.proposal);
  loading = new LoadingState();

  constructor(private readonly orgId: OrgId) {
    super();
  }

  proposals$ = this.proposalBloc.proposals$;

  onInit() {
    return forkJoin([this.proposalBloc.fetchProposals({ orgId: this.orgId })]).pipe(this.loading.run());
  }

  onReload = () => {
    return this.proposalBloc.fetchProposals({ orgId: this.orgId });
  };

  updateStatus = this.proposalBloc.updateStatus;
  deleteProposal = this.proposalBloc.deleteProposal;
  unarchiveProposal = this.proposalBloc.unarchiveProposal;
  updateTitle = this.proposalBloc.updateTitle;
  newDuplicateProposal = this.proposalBloc.newDuplicateProposal;
  hardDeleteProposal = this.proposalBloc.hardDeleteProposal;
  printProposal = this.proposalBloc.printProposal;
}
